// TODO move to @mallardbay/lib-react-components
// eslint-disable-next-line no-restricted-imports
import type { TextProps } from "@chakra-ui/react"
// TODO move to @mallardbay/lib-react-components
// eslint-disable-next-line no-restricted-imports
import { Text, useTheme } from "@chakra-ui/react"
import React from "react"
import type { CustomTheme } from "@mallardbay/lib-react-components"

export default function SubLabel({ children }: TextProps) {
    const styles = useStyles()

    return <Text {...styles.text}>{children}</Text>
}

function useStyles() {
    const { colors } = useTheme<CustomTheme>()

    const text: TextProps = {
        fontSize: "12px",
        color: colors.custom.gray,
    }

    return {
        text,
    }
}
